import React, { useCallback, useEffect, useState } from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField, CircularProgress, Typography, List, ListSubheader, ListItem, ListItemText } from '@mui/material';
import Grid from '@mui/system/Unstable_Grid';
import * as yup from 'yup';
import { useFormik } from 'formik';
import { debounce } from 'lodash';
1;
const DialogPesquisa = ({ onClose, service, ...props }) => {
    const [loading, setLoading] = useState(false);
    const [produtos, setProdutos] = useState([]);
    const form = useFormik({
        initialValues: {
            pesquisa: ''
        },
        validationSchema: yup.object({
            pesquisa: yup.string().required('O campo é obrigatório')
        }),
        validateOnMount: false,
        onSubmit: async (values) => {
            onClose();
        }
    });
    // Versão debounceada da função de busca
    const debouncedSearch = useCallback(debounce(async (value) => {
        setLoading(true);
        const p = await service.procuraProdutoStock(value);
        if (p) {
            setProdutos(p);
        }
        setLoading(false);
    }, 350), []);
    // Monitora mudanças no valor do campo 'search'
    useEffect(() => {
        const value = form.values.pesquisa;
        if (value.trim().length >= 3) {
            debouncedSearch(value.trim());
        }
    }, [form.values.pesquisa, debouncedSearch]);
    return (<Dialog {...props}>
      <form>
        <DialogTitle>Pesquisa de stock</DialogTitle>
        <DialogContent>
          <Grid container spacing={2} sx={{ mt: 1 }}>
            <Grid lg={12} md={12} xs={12}>
              <Typography>Para pesquisar um produto, pode utilizar códigos de artigo ou palavras-chave da designação registada. (mínimo 3 letras para pesquisa).</Typography>
            </Grid>
            <Grid lg={12} md={12} xs={12}>
              <TextField InputProps={{
            endAdornment: <React.Fragment>{loading ? <CircularProgress color='inherit' size={20}/> : null}</React.Fragment>
        }} label='Termo a pesquisar *' name='pesquisa' defaultValue={form.values?.pesquisa} onChange={form.handleChange} onBlur={form.handleBlur} fullWidth error={form.touched.pesquisa && Boolean(form.errors.pesquisa)} helperText={form.touched.pesquisa && form.errors.pesquisa}/>
            </Grid>
            {produtos.length > 0 && loading == false ? (<List sx={{
                width: '100%',
                overflow: 'auto',
                maxHeight: 300
            }} subheader={<ListSubheader>
                    Foram encontrados {produtos.length} produtos. {produtos.length > 10 ? 'Para um controlo mais fino, introduza um termo de pesquisa maior.' : ''}
                  </ListSubheader>}>
                {produtos.map(r => {
                return (<ListItem key={r.id}>
                      <ListItemText primary={`${r.primaveraId} - ${r.designacao}`} secondary={r.stock
                        .map(s => {
                        return `Armazém: ${s.armazem}, Quantidade: ${s.quantidade}`;
                    })
                        .join(' | ')}></ListItemText>
                    </ListItem>);
            })}
              </List>) : (<></>)}
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => {
            onClose();
        }}>
            Cancelar
          </Button>
          <Button onClick={() => {
            form.handleSubmit();
        }} disabled={!form.isValid || !form.dirty || form.isSubmitting} variant='contained'>
            OK
          </Button>
        </DialogActions>
      </form>
    </Dialog>);
};
export default DialogPesquisa;
